import React, { useState, useContext } from "react";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiCloseCircleLine } from "react-icons/ri";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import ButtonUI from "../material-ui/ButtonUI";
import changeContractTemplatesStatus from "../../api/changeContractTemplatesStatus";
import { AuthContext } from "../../context/Auth/AuthContext";

const StatusPopup = ({ setContractTemplatesAddedToTrue, tableValues }) => {
  const [open, setOpen] = useState(false);
  const { token, user_id, is_admin } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeStatusFormSubmit = async () => {
    const changeStatusFormResponse = await changeContractTemplatesStatus({
      token: token,
      user_id: user_id,
      contract_request_setting_id: tableValues.contract_request_setting_id,
      status: tableValues.status === "active" ? "inactive" : "active",
      is_admin: is_admin,
    });

    if (changeStatusFormResponse?.code === 200) {
      setContractTemplatesAddedToTrue();
      setOpen(false);
      showSuccess("Contract Template Status is successfully changed");
    } else {
      showError("Error while updating Contract Template Status");
    }
  };

  return (
    <div className="dialog-modal">
      <ButtonUI
        formButton={false}
        variant="outlined"
        buttonText={
          tableValues.status === "inactive" ? (
            <RiCloseCircleLine />
          ) : (
            <HiOutlineCheckCircle />
          )
        }
        style={{
          color:
            tableValues.status === "inactive" ? "#e0a800" : "#28a745",
          marginRight: "5px",
          padding: "6px",
          minWidth: "fit-content",
          border: "none",
          boxShadow: "none",
          fontSize: "18px",
        }}
        sx={{
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor:
              tableValues.status === "inactive"
                ? "rgba(255, 193, 7, 0.15)"
                : "rgba(40, 167, 69, 0.12)",
          },
        }}
        onClickFunc={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            {tableValues.status === "inactive" ? (
              <HiOutlineCheckCircle />
            ) : (
              <RiCloseCircleLine />
            )}
          </div>
          <div className="popup-header-title">
            Change Contract Template Status
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to change Contract Template status ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onChangeStatusFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StatusPopup;
